export default __webpack_public_path__ + "static/media/splash-image-03.d48e5bdd.png";